// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__211Fd","info":"Note_info__148_o","note":"Note_note__2W0qa","actions":"Note_actions__4ZmVa"};